import dayjs from 'dayjs';

/**
 * 日付をYYYY-MMにフォーマットして返却します
 * @param {String} date
 */
export const getYearMonth = date => {
  return date ? dayjs(date).format('YYYY-MM') : null;
};
